import { ResponsiveLine } from '@nivo/line';
import { e4Format, e4Formats } from 'helpers/dates';
import React from 'react';

export const Overtime = ({ data }) => {
    const setData = [{ id: 'Overtime', data: data.map(p => ({ ...p, x: new Date(p.x) })) }];

    const firstX = setData[0].data[0].x;
    const lastX = setData[0].data[setData[0].data.length - 1].x;

    return (
        <ResponsiveLine
            data={setData}
            margin={{ top: 10, right: 10, bottom: 25, left: 20 }}
            xScale={{
                type: 'time',
                useUTC: false,
                precision: 'day',
                min: 'auto',
                max: 'auto',
            }}
            yScale={{ type: 'linear' }}
            curve="monotoneX"
            theme={{
                axis: {
                    domain: {
                        line: {
                            stroke: 'rgba(0,0,0,0.6)',
                            strokeWidth: 1,
                        },
                    },
                    ticks: {
                        line: {
                            stroke: 'transparent', // keep tick marks hidden
                        },
                        text: {
                            fill: 'rgba(0,0,0,0.6)',
                        },
                    },
                },
            }}
            axisBottom={{
                tickValues: [firstX, lastX],
                format: v => e4Format(v instanceof Date ? v : new Date(v), e4Formats.monthShort),
                tickSize: 0,
                tickPadding: 8,
            }}
            axisLeft={{
                tickValues: [0, 1, 2, 3, 4, 5],
                tickSize: 0,
                tickPadding: 8,
                tickRotation: 0,
                legendOffset: -50,
                legendPosition: 'middle',
            }}
            enableGridY={false}
            enableGridX={false}
            lineWidth={1.2}
            enableArea
            areaOpacity={0.2}
            areaBaselineValue={0}
            areaBlendMode="normal"
            areaColors={['#FFB86B']}
            colors={['#FFB86B']}
            pointSize={8}
            pointColor="#FFB86B"
            pointBorderWidth={0}
            pointLabelYOffset={-12}
            useMesh
            tooltip={({ point }) => {
                const date = point.data.x instanceof Date ? point.data.x : new Date(point.data.x);

                return (
                    <div
                        style={{
                            padding: '6px 10px',
                            background: 'white',
                            border: '1px solid #ccc',
                            fontSize: 12,
                        }}
                    >
                        <strong>
                            {e4Format(date, 'MMM yy')}: {point.data.y}
                        </strong>
                    </div>
                );
            }}
        />
    );
};
